import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import WithRender from './recepientDetails.html';
import _axios from '@/services/axios';
import { RecepientDetail } from '@/types/CartTypes';
import { relativeTimeThreshold } from 'moment';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  components: {
    Loading,
    VuePhoneNumberInput,
  },
  computed: {
    ...mapGetters("recepientDetail", {recepient:"getRecepient"}),
  }
})
export default class RecepientDetails extends Vue {
  isLoading = false;
  fullPage = true;
  showNotification: boolean = false;
  notificationMessage: string = "";
  valideSenderNumberMessage: string = "";
  valideReceiverNumberMessage: string = "";
  valideReceiverFirstNameMessage: string = "";
  valideReceiverSurnameMessage: string = "";
  senderNumber: string = "";
  receiverNumber: string = "";
  isSenderNumberValid: boolean = false;
  isReceiverNumberValid: boolean = false;
  recepient!: RecepientDetail;


  ValidateSenderNumber(payload: any) {
    if (payload.isValid) {
      this.valideSenderNumberMessage = "";
      this.recepient.senderNumber = payload.countryCallingCode + payload.nationalNumber;
      this.isSenderNumberValid = true;
    } else {
      this.valideSenderNumberMessage = "Please make sure mobile number is valid!";
      this.isSenderNumberValid = false;
    }
  }

  ValidateReceiverNumber(payload: any) {
    if (payload.isValid) {
      this.valideReceiverNumberMessage = "";
      this.recepient.receiverNumber = payload.countryCallingCode + payload.nationalNumber;
      this.isReceiverNumberValid = true;
    } else {
      this.valideReceiverNumberMessage = "Please make sure mobile number is valid!";
      this.isReceiverNumberValid = false;
    }
  }

  ValidateDetails() : boolean
  {
    if((!this.recepient.surname))
      {
        this.valideReceiverSurnameMessage = "Recepient Surname is required";
        return false;
      }
      if(!(this.recepient.firstName))
      {
        this.valideReceiverFirstNameMessage = "Recepient First name is required";
        return false;
      }
    return true;
  }

  async proceed()
  {
    if(!this.isSenderNumberValid || !this.isReceiverNumberValid || !this.ValidateDetails())
      {
        this.$bvToast.toast('Please make sure you have provided all required details', {
          title: 'Notification',
          variant: 'danger',
          autoHideDelay: 5000,
        })
        return;
      }
    await this.$store.dispatch("recepientDetail/addRecepient",this.recepient);
    this.$router.push({name:'gridcheckout'})
  }
}